/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpinWheelRequest
 */
export interface SpinWheelRequest {
    /**
     * Board space position where spin wheel is located
     * @type {number}
     * @memberof SpinWheelRequest
     */
    spacePosition: number;
}

/**
 * Check if a given object implements the SpinWheelRequest interface.
 */
export function instanceOfSpinWheelRequest(value: object): value is SpinWheelRequest {
    if (!('spacePosition' in value) || value['spacePosition'] === undefined) return false;
    return true;
}

export function SpinWheelRequestFromJSON(json: any): SpinWheelRequest {
    return SpinWheelRequestFromJSONTyped(json, false);
}

export function SpinWheelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'spacePosition': json['spacePosition'],
    };
}

export function SpinWheelRequestToJSON(json: any): SpinWheelRequest {
    return SpinWheelRequestToJSONTyped(json, false);
}

export function SpinWheelRequestToJSONTyped(value?: SpinWheelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spacePosition': value['spacePosition'],
    };
}

